const ITEMS = [
  "Excellence in Construction",
  "Structural Integrity",
  "CDM 2015 Compliant",
  "London & UK-Wide",
  "Built on Trust",
];

export const Marquee = () => (
  <section
    aria-hidden="true"
    data-testid="marquee-section"
    className="overflow-hidden border-y border-black/10 bg-coal py-8"
  >
    <div className="animate-marquee flex w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {ITEMS.map((text, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span
                className={`whitespace-nowrap px-10 font-display text-5xl font-bold uppercase tracking-tight md:text-7xl ${
                  i % 2 === 0 ? "text-outline" : "text-ink/90"
                }`}
              >
                {text}
              </span>
              <span className="h-2.5 w-2.5 bg-bronze" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
